module.exports = __webpack_public_path__ + "static/img/2.2b03b81a.png";